<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <article>
        <h2>회원가입</h2>
        <ul class="breadCrumb">
          <li class="home"></li>
          <li>
            <p class="pageTxt">회원가입(일반)</p>
            <ul class="depth">
              <li><router-link to="/membershipagreement" title="회원가입(일반)">회원가입(일반)</router-link></li>
              <li><router-link to="/businessagreement" title="회원가입(사업자)">회원가입(사업자)</router-link></li>
            </ul>
          </li>
        </ul>
      </article>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <!--stepArea-->
        <div class="stepArea web">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li class="on">
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
            <li>
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
          </ul>
        </div>
        <div class="stepArea mobile">
          <ul>
            <li class="on">
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li class="on">
              <span>2</span>
              <p>본인인증</p>
            </li>
            <li>
              <span>4</span>
              <p>회원가입 신청완료</p>
            </li>
            <li>
              <span>3</span>
              <p>정보입력</p>
            </li>
          </ul>
        </div>
        <!--//stepArea-->

        <h3 class="pageTitle">본인확인</h3>
        <div class="authentication">
          <p class="subTile">
            본인인증 시 제공되는 정보는 인증 기관에서 수집하며<br />
            본인확인 외 다른 용도로 이용 또는 저장되지 않습니다.
          </p>
        </div>

        <!--btnArea-->
        <div class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('/membershipagreement')">취소</button>
          <button type="button" class="btn blue" @click="Certification">휴대폰 인증</button>
        </div>
        <!--//btnArea-->
      </div>
    </section>

    <!-- 본인인증 -->
    <pop-up v-if="showModal">
      <template #info> 본인인증 </template>
      <template #content>
        <article class="paragraph">
          <p>휴대폰 본인 인증을 진행해주세요.</p>
        </article>
        <article>
          <div class="table pop-table">
            <table>
              <caption>
                본인인증 테이블
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">이름</th>
                  <td>
                    <input type="text" title="이름 입력" v-model="name" />
                    <div class="error" v-if="!$v.name.required">이름을 입력해주세요.</div>
                  </td>
                </tr>
                <tr>
                  <th scope="row">휴대폰 번호</th>
                  <td>
                    <div class="tell">
                      <input
                        type="text"
                        maxlength="3"
                        title="휴대폰 식별번호 선택"
                        v-model="firstNumber"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="휴대폰 앞 4자리 입력"
                        v-model="secondNumber"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                      <input
                        type="text"
                        maxlength="4"
                        title="휴대폰 뒤 4자리 입력"
                        v-model="lastNumber"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                      />
                    </div>
                    <div>
                      <div
                        class="error"
                        v-if="!$v.firstNumber.required || !$v.secondNumber.required || !$v.lastNumber.required"
                      >
                        번호를 입력해주세요.
                      </div>
                      <div
                        class="error"
                        v-if="
                          !(
                            $v.firstNumber.mobileRegex &&
                            $v.secondNumber.mobileRegex &&
                            $v.lastNumber.mobileRegex &&
                            $v.firstNumber.minLength &&
                            $v.secondNumber.minLength &&
                            $v.lastNumber.minLength
                          )
                        "
                      >
                        휴대폰 번호를 확인해주세요
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </article>
        <article class="btnArea">
          <button class="btn gray" @click="CancleBtn">취소</button>
          <button class="btn blue" @click="sendAuthNum">인증번호 요청</button>
        </article>
        <article v-show="authArticle">
          <div class="table pop-table">
            <table>
              <caption>
                휴대폰 인증
              </caption>
              <colgroup>
                <col style="width: 20%; min-width: 80px" />
                <col style="width: 80%" />
              </colgroup>
              <tbody>
                <tr>
                  <th scope="row">인증번호</th>
                  <td>
                    <div class="flex timeInput">
                      <div class="timer">
                        <input type="text" placeholder="인증번호 6자리" title="인증번호 입력" v-model="inputPinNo" />
                        <span class="time" v-show="showTimeMsg">{{ TimerStr }}</span>
                      </div>
                      <button class="btn border" @click="extension">시간연장</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <article class="btnArea">
            <button class="btn gray" @click="CancleBtn">취소</button>
            <button class="btn blue" @click="ConfirmBtn">확인</button>
          </article>
          <article class="paragraph notice">
            <p>인증번호 문자를 못 받으셨나요?</p>
            <p>인증번호가 문자로 수신되지 않을 경우 정확한 정보로 재시도해 주시기 바랍니다.</p>
          </article>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </pop-up>

    <!-- 인증번호 안내(불일치) -->
    <alert-notmatch v-show="showModalMsgFailure">
      <template #content>
        <p>{{ msg1 }}</p>
        <p>{{ msg2 }}</p>
        <article class="btnArea">
          <button class="btn blue" @click="CloseBtn">확인</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-notmatch>

    <!-- 인증번호 안내(일치) -->
    <alert-match v-show="showModalMsgSuccess">
      <template #content>
        <p>{{ msg3 }}</p>
        <article class="btnArea">
          <button class="btn gray" @click="CloseBtn">취소</button>
          <button class="btn blue" @click="nextStep">다음단계로 이동</button>
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </alert-match>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import PopUp from '../../../components/PopupType1.vue';
import AlertNotmatch from '../../../components/Alert02.vue';
import AlertMatch from '../../../components/Alert01.vue';
import dayjs from 'dayjs';
import { required, helpers, minLength } from 'vuelidate/lib/validators';
const mobileRegex = helpers.regex('mobileRegex', /\d$/);

export default {
  data() {
    return {
      showModal: false,
      showModalMsgFailure: false,
      showModalMsgSuccess: false,
      authArticle: false,

      msg1: '인증번호가 일치하지 않습니다',
      msg2: '인증번호를 확인해주세요.',
      msg3: '인증이 완료되었습니다.',

      name: '',
      firstNumber: '',
      secondNumber: '',
      lastNumber: '',
      pinNo: '',
      inputPinNo: '',

      TimeCounter: '',
      TimerStr: '',
      TimeMsg: '',
      showTimeMsg: false,
    };
  },

  validations: {
    name: {
      required,
    },
    firstNumber: {
      required,
      mobileRegex,
      minLength: minLength(3),
    },
    secondNumber: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
    lastNumber: {
      required,
      mobileRegex,
      minLength: minLength(4),
    },
  },

  components: {
    PopUp,
    AlertMatch,
    AlertNotmatch,
  },

  methods: {
    Certification() {
      this.showModal = true;
    },

    CancleBtn() {
      this.showModal = false;
      this.showModalMsgFailure = false;
      this.showModalMsgSuccess = false;
    },

    CloseBtn() {
      this.showModal = false;
      this.showModalMsgFailure = false;
      this.showModalMsgSuccess = false;
    },

    async sendAuthNum() {
      if (this.$v.$invalid) {
        alert('이름, 핸드폰번호를 다시 확인해주세요.');
        return;
      }
      const res = await axios('get', '/api/member/mobileCk.json', {
        empMobile: this.firstNumber + this.secondNumber + this.lastNumber,
      });
      const data = res.data.result;
      if (data !== true) {
        alert('이미 가입된 핸드폰 번호입니다.');
        return;
      }

      this.TimeCounter = 180;
      this.TimerStr = '03:00';
      this.timerStart();
      this.authArticle = true;
      await axios('get', '/api/member/send.json', {
        rcvAddr: this.firstNumber + this.secondNumber + this.lastNumber,
      });
      this.timerStop();
    },

    async ConfirmBtn() {
      const apiParams = new FormData();
      apiParams.append('pinNo', this.inputPinNo);
      const res = await axios('post', '/api/member/pinNoChk.json', apiParams);
      if (res.data.result != btoa(this.inputPinNo + dayjs(new Date()).format('YYYYMMDD')) || !res.data.result) {
        alert('인증번호를 다시 확인해주세요.');
        return;
      }
      this.showModal = false;
      this.showModalMsgSuccess = true;
    },

    nextStep() {
      this.$router.push({
        name: 'membershipinfomation',
        params: {
          name: this.name,
          mobile: this.firstNumber + this.secondNumber + this.lastNumber,
        },
      });
    },

    timerStart() {
      this.showTimeMsg = true;
      this.interval = setInterval(() => {
        this.TimeCounter--;
        this.TimerStr = this.prettyTime();
        if (this.TimeCounter <= 0) this.timerStop();
      }, 1000);
      return this.interval;
    },

    timerStop() {
      clearInterval(this.interval);
      this.showTimeMsg = false;
    },

    prettyTime() {
      let time = this.TimeCounter / 60;
      let minutes = parseInt(time);
      let secondes = Math.round((time - minutes) * 60);
      this.TimeMsg = minutes.toString().padStart(2, '0') + ':' + secondes.toString().padStart(2, '0');
      return minutes.toString().padStart(2, '0') + ':' + secondes.toString().padStart(2, '0');
    },

    extension() {
      if (confirm('시간을 연장 하시겠습니까?')) {
        clearInterval(this.interval);
        this.TimeCounter = 180;
        this.TimerStr = '03:00';
        this.timerStart();
      }
    },
  },
};
</script>
